// extracted by mini-css-extract-plugin
module.exports = {"default":"SauceLogo__default__3k5gh"};